module.exports = __webpack_public_path__ + "img/20.ddef1306.svg";